import { isEmpty, sumBy } from 'lodash';

const nestingCriterionValidator = (
  { relations, hasQuotas } = {},
  { completes } = {},
) => {
  const errors = {};

  if (isEmpty(relations)) {
    errors.requiredRelations = true;
  }

  if (hasQuotas) {
    const criterionQuotaSum = sumBy(relations, 'quotaCompletes');
    const quotaSumError = completes && criterionQuotaSum < completes;
    if (quotaSumError) {
      errors.quotaSumError = true;
    }
  }

  return errors;
};

export default nestingCriterionValidator;
